module.exports = __webpack_public_path__ + "static/home_desktop-3630a9371940eb7812a8eda248c130f4.png";